import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './tagList.module.css'

interface IProps {
  children: any
  expandable?: boolean
}

interface IState {
  hidden: boolean
}

class TagList extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { hidden: !!props.expandable }
    this.toggleHidden = this.toggleHidden.bind(this)
  }

  public render() {
    const { hidden } = this.state
    const { expandable } = this.props

    return (
      <div className={classnames(styles.root, { [styles.hidden]: hidden })}>
        <span className={styles.tagList}>Tags: {this.props.children}</span>
        {expandable && (
          <span
            role="button"
            className={styles.seeAllTags}
            onClick={this.toggleHidden}
          >
            See {hidden ? 'all' : 'less'} tags
          </span>
        )}
      </div>
    )
  }

  private toggleHidden() {
    this.setState({ hidden: !this.state.hidden })
  }
}

export default TagList
